export default __webpack_public_path__ + "static/media/large-checkmark.4152df47.svg";